import React from 'react';
import PropTypes from 'prop-types';
import { TableCell } from 'smartsuite-ui';
import { getFormattedValue } from '../../../dashboardUtils';
import useLink from '../../../../shared/hooks/linkHooks';

// eslint-disable-next-line complexity
export default function DashboardLink({
    columnConfig,
    metricRequest,
    dataRow,
    formatValue,
    openLinksInNewTab,
    value,
}) {
    const linkUri = useLink(columnConfig, metricRequest, dataRow);

    return (
        <TableCell
            cssClassModifiers={[columnConfig.isLeftAligned ? 'left-align' : '']}
        >
            <a
                href={linkUri}
                target={openLinksInNewTab ? '_blank' : ''}
                rel="noreferrer"
            >
                {getFormattedValue(value, columnConfig.suffix, formatValue)}
            </a>
        </TableCell>
    );
}

DashboardLink.propTypes = {
    columnConfig: PropTypes.instanceOf(Object).isRequired,
    dataRow: PropTypes.instanceOf(Object).isRequired,
    metricRequest: PropTypes.instanceOf(Object).isRequired,
    formatValue: PropTypes.func.isRequired,
    openLinksInNewTab: PropTypes.bool.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
